import { forwardRef, type HTMLAttributes } from 'react';
import clsx from 'clsx';

import styles from './Kbd.module.css';

export interface KbdProps extends Omit<HTMLAttributes<HTMLElement>, 'children'> {
  /**
   * The chord, one entry per key: `['Shift', 'K']`. Rendered as separate keycaps
   * joined by a thin plus, because the keyboard placement strip has to teach the
   * chord, not just print it.
   */
  keys: readonly string[];
}

export const Kbd = forwardRef<HTMLElement, KbdProps>(function Kbd({ keys, className, ...rest }, ref) {
  return (
    <span {...rest} ref={ref} className={clsx(styles.group, className)}>
      {keys.map((key, index) => (
        <span className={styles.slot} key={`${key}-${String(index)}`}>
          {index > 0 && (
            <span className={styles.plus} aria-hidden="true">
              +
            </span>
          )}
          <kbd className={styles.key}>{key}</kbd>
        </span>
      ))}
    </span>
  );
});
